export const sighuPaths = {
  base: 'sighu',
  sighuHome: 'home',
  profile: 'profile',
  certificate: 'certificate',
  queries: 'queries',
  compensatoryTimes: 'compensatory-times',
};

export const sighuRoutes = {
  sighuHome: `/${sighuPaths.base}/${sighuPaths.sighuHome}`,
  sighuProfile: `/${sighuPaths.base}/${sighuPaths.profile}`,
  sighuCertificate: `/${sighuPaths.base}/${sighuPaths.certificate}`,
  sighuQueries: `/${sighuPaths.base}/${sighuPaths.queries}`,
  sighuCompensatoryTimes: `/${sighuPaths.base}/${sighuPaths.compensatoryTimes}`,
};
